export default __webpack_public_path__ + "static/media/Stars.cb6c1355.png";